import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { API_ENDPOINTS } from '../config/api';
import { adminApi } from '../services/adminApi';
import { clearAdminCapabilities } from '../utils/adminPermissions';

interface AdminPrivateRouteProps {
  children: React.ReactNode;
}

const AdminPrivateRoute: React.FC<AdminPrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminAccess = async () => {
      const clearAdminSession = () => {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_level');
        localStorage.removeItem('admin_user_id');
        localStorage.removeItem('user_id');
        clearAdminCapabilities();
      };

      // CHỈ CHECK admin_token - KHÔNG BAO GIỜ DÙNG token hoặc auth_token của user thường
      const adminToken = localStorage.getItem('admin_token');
      
      if (!adminToken) {
        clearAdminSession();
        setIsChecking(false);
        setIsAdmin(false);
        return;
      }

      // Kiểm tra quyền admin bằng endpoint profile chung để tránh lỗi khi user không có quyền dashboard
      try {
        const response = await fetch(`${API_ENDPOINTS.ADMIN_ME}`, {
          headers: {
            'Authorization': `Bearer ${adminToken}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status === 403) {
          console.warn('User không có quyền admin - xóa admin session và redirect về login');
          clearAdminSession();
          setIsAdmin(false);
        } else if (response.ok) {
          try {
            await adminApi.syncAdminSessionFromMe();
          } catch (meError) {
            console.warn('Could not load admin permissions profile', meError);
          }
          setIsAdmin(true);
        } else if (response.status === 401) {
          console.warn('Admin token hết hạn hoặc không hợp lệ - chuyển về admin login');
          clearAdminSession();
          setIsAdmin(false);
        } else {
          // Lỗi tạm (500/502): vẫn cho vào nếu đã có admin_token, tránh chặn /home.
          setIsAdmin(true);
        }
      } catch (error) {
        console.error('Error checking admin access:', error);
        // Mất mạng: vẫn cho vào trang admin/home nếu còn token.
        setIsAdmin(Boolean(localStorage.getItem('admin_token')));
      } finally {
        setIsChecking(false);
      }
    };

    checkAdminAccess();
  }, []);

  if (isChecking) {
    // Hiển thị loading trong khi kiểm tra
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-gray-100 border-t-[#C4A35A]"></div>
      </div>
    );
  }

  if (!isAdmin) {
    // Không phải admin hoặc không có token - redirect về login
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Có quyền admin - render children
  return <>{children}</>;
};

export default AdminPrivateRoute;

